import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from 'src/contexts';
import { useHttp } from 'src/hooks';

const InstagramCallback = () => {
  const navigate = useNavigate();
  const { sendRequest } = useHttp();
  const { fetchProfile } = useContext(AuthContext);

  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get('code');
  const state = urlParams.get('state');
  const fetchInstagramUser = () => {
    sendRequest(
      {
        url: `instagram/callback?code=${code}&state=${state}`,
        method: 'GET',
      },
      (data: any) => {
        fetchProfile();
        navigate('/dashboard/account-setup');
      },
    );
  };

  useEffect(() => {
    fetchInstagramUser();
  }, []);
  return <div></div>;
};

export default InstagramCallback;
